import { useDesignerStore, type NavigationMode } from "@/state/designerStore";
import { EditModeIcon, OrbitIcon, PanIcon, ZoomIcon } from "./Icons";

const MODES: ReadonlyArray<{
  id: NavigationMode;
  label: string;
  hint: string;
  icon: React.ReactElement;
}> = [
  { id: "sculpt", label: "Shape", hint: "Drag the model with the selected tool", icon: <EditModeIcon /> },
  { id: "orbit", label: "Orbit", hint: "One-finger or left-button drag to orbit", icon: <OrbitIcon /> },
  { id: "pan", label: "Pan", hint: "One-finger or left-button drag to pan", icon: <PanIcon /> },
  { id: "zoom", label: "Zoom", hint: "Pinch, scroll or left-button drag to zoom", icon: <ZoomIcon /> },
];

/** Explicit camera modes make laptop touchpads usable without a middle button. */
export function NavigationDock(): React.ReactElement {
  const mode = useDesignerStore((s) => s.navigationMode);
  const setMode = useDesignerStore((s) => s.setNavigationMode);

  return (
    <div className="panel nav-dock" role="group" aria-label="Touchpad movement tools">
      {MODES.map((item) => (
        <button
          key={item.id}
          type="button"
          className="nav-tool"
          aria-label={`${item.label}: ${item.hint}`}
          aria-pressed={mode === item.id}
          data-tooltip={`${item.label} · ${item.hint}`}
          onClick={() => setMode(item.id)}
        >
          {item.icon}
        </button>
      ))}
    </div>
  );
}
